// Machine-authored for Phase 6c; requires review by a native Arabic speaker.
const authentication = {
  loginMarketingHeadline: "الطريقة الأسهل لإدارة أسطولك",
  loginMarketingSubtitle:
    "تابع مركباتك، صيانتك، وسائقيك في مكان واحد. وفّر وقتك وركّز على نمو أعمالك",
  // The login's marketing panel (LoginArtwork), as Figma's copy with its
  // spelling corrected (hamzas, taa marbuta).
  loginArt: {
    eyebrow: "تتبع مباشر",
    headline: "الطريق الأسهل،",
    headlineAccent: "لإدارة أصولك.",
    lead: "تابع كل رحلة لحظة بلحظة، واكتشف المشاكل قبل أن تعطّل عملياتك.",
    liveTag: "مباشر · 42 أصلًا تتحدث الآن",
    depot: "مستودع مدينة جدة",
    alerts: {
      speeding: "سرعة زائدة · 96 كم/س",
      idle: "متوقفة · 12 دقيقة",
    },
    tracked: {
      status: "في حركة",
      unit: "كم/س",
      arrival: "الوصول {{time}}",
    },
    stats: {
      onRoad: "في الطريق الآن",
      maintenance: "صيانة مستحقة",
      onTime: "تسليم في الموعد",
    },
  },
  otpArt: {
    eyebrow: "تحقق آمن",
    headline: "رمز واحد،",
    headlineAccent: "وحسابك في أمان.",
    lead: "أدخل الرمز المرسل إلى بريدك الإلكتروني لإكمال تسجيل الدخول بأمان.",
    sentTitle: "تم إرسال الرمز",
    sentTo: "إلى بريدك الإلكتروني",
    expiresIn: "ينتهي خلال",
    verified: "تم التحقق بنجاح",
    stats: {
      encryption: "تشفير كامل",
      validity: "صلاحية الرمز",
      attempts: "محاولات متبقية",
    },
  },
  loginTitle: "مرحباً بعودتك!",
  loginSubtitle: "من فضلك أدخل بياناتك لتسجيل الدخول",
  usernameLabel: "اسم المستخدم",
  usernamePlaceholder: "اسم المستخدم",
  passwordLabel: "كلمة المرور",
  passwordPlaceholder: "أدخل كلمة المرور",
  showPassword: "عرض كلمة المرور",
  hidePassword: "إخفاء كلمة المرور",
  forgotPasswordLink: "هل نسيت كلمة المرور؟",
  signInButton: "تسجيل الدخول",
  signingInButton: "جاري تسجيل الدخول...",
  sessionTimedOut:
    "انتهت مهلة جلستك بسبب عدم النشاط. يُرجى تسجيل الدخول مرة أخرى.",
  sessionTimeoutWarningTitle: "تنبيه انتهاء الجلسة",
  sessionTimeoutWarningMessage:
    "سيتم تسجيل خروجك تلقائياً بسبب عدم النشاط خلال",
  sessionTimeoutStayButton: "متابعة الجلسة",
  invalidCredentials:
    "اسم المستخدم أو كلمة المرور غير صحيحة. يُرجى المحاولة مرة أخرى.",

  otpTitle: "تحقق من رمزك",
  otpSubtitle: "أدخل رمز التحقق الذي استلمته للتو على {{destination}}.",
  otpDidNotReceive: "لم يصلك الرمز؟",
  otpCodeLabel: "رمز التحقق",
  otpCodePlaceholder: "123456",
  verifyButton: "تأكيد الرمز",
  verifyingButton: "جاري التحقق...",
  verifiedButton: "تم التحقق بنجاح",
  resendOtpButton: "إعادة إرسال الرمز",
  resendingOtpButton: "جاري إعادة الإرسال...",
  resendOtpCountdown: "إعادة الإرسال خلال {{seconds}} ثانية",
  resendOtpCountdownTime: "إعادة الإرسال خلال {{time}}",
  otpResentSuccess: "تمت إعادة إرسال رمز التحقق بنجاح.",
  invalidOtp: "رمز التحقق غير صحيح. يُرجى التأكد والمحاولة مرة أخرى.",
  noOtpInProgress:
    "لا يوجد طلب تحقق قيد التنفيذ حالياً. يُرجى تسجيل الدخول مرة أخرى.",

  forgotPasswordTitle: "نسيت كلمة المرور؟",
  forgotPasswordSubtitle:
    "أدخل بريدك الإلكتروني المسجل وسنرسل لك رمز تحقق لإعادة تعيين كلمة المرور.",
  emailLabel: "البريد الإلكتروني",
  emailPlaceholder: "name@company.com",
  sendResetCodeButton: "إرسال الرمز",
  sendingResetCodeButton: "جاري إرسال الرمز...",
  sendResetCodeCountdown: "حاول مرة أخرى خلال {{time}}",

  resetPasswordTitle: "قم بإنشاء كلمة مرور جديدة",
  resetPasswordSubtitle: "يرجى إدخال كلمة المرور الجديدة أدناه.",
  newPasswordLabel: "كلمة المرور الجديدة",
  newPasswordPlaceholder: "أدخل كلمة المرور الجديدة",
  confirmPasswordLabel: "تأكيد كلمة المرور",
  confirmPasswordPlaceholder: "أعد إدخال كلمة المرور الجديدة",
  resetPasswordButton: "إعادة تعيين كلمة المرور",
  resettingPasswordButton: "جاري إعادة التعيين...",
  resetPasswordSuccessTitle: "تمت إعادة تعيين كلمة المرور بنجاح",
  resetPasswordSuccessDescription:
    "تم تحديث كلمة المرور بنجاح. يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديدة.",

  passwordReqMinLength: "8 أحرف على الأقل",
  passwordReqUppercase: "حرف كبير واحد (A-Z)",
  passwordReqLowercase: "حرف صغير واحد (a-z)",
  passwordReqNumber: "رقم واحد على الأقل",
  passwordReqSpecialChar: "رمز واحد على الأقل (@!#$%^&*)",

  activateAccountTitle: "قم بتعيين كلمة المرور الخاصة بك",
  activateAccountSubtitle: "قم بتعيين كلمة المرور لإتمام تفعيل حسابك.",
  activateAccountSubtitleWithEmail:
    "أنشئ كلمة مرور لتفعيل حساب مسؤول الشركة الخاص بـ {{email}}.",
  activateAccountButton: "تفعيل الحساب",
  activatingAccountButton: "جاري تفعيل الحساب...",
  activateAccountSuccessTitle: "تم تفعيل الحساب بنجاح",
  activateAccountSuccessDescription:
    "تم تفعيل حسابك بنجاح. يمكنك الآن تسجيل الدخول.",

  checkingLink: "جاري التحقق من صلاحية الرابط...",
  linkValidTitle: "الرابط صالح",
  linkValidDescription: "هذا الرابط صالح ويمكنك المتابعة.",
  linkExpiredTitle: "انتهت صلاحية الرابط",
  linkExpiredDescription: "انتهت صلاحية هذا الرابط. يُرجى طلب رابط جديد.",
  linkAlreadyUsedTitle: "تم استخدام الرابط مسبقاً",
  linkAlreadyUsedDescription:
    "تم استخدام هذا الرابط بالفعل. يُرجى تسجيل الدخول أو طلب رابط جديد.",
  linkSupersededTitle: "تم استبدال الرابط",
  linkSupersededDescription:
    "تم إرسال رابط تفعيل أحدث. يُرجى استخدام أحدث بريد إلكتروني.",
  linkInvalidTitle: "الرابط غير صالح",
  linkInvalidDescription:
    "هذا الرابط غير صالح أو غير مكتمل. يُرجى التحقق من الرابط أو طلب رابط جديد.",
  resendActivationLinkButton: "إعادة إرسال رابط التفعيل",
  resendingActivationLinkButton: "جاري إرسال رابط التفعيل...",
  activationLinkResentSuccess: "تم إرسال رابط تفعيل جديد إلى بريدك الإلكتروني.",

  backToLogin: "العودة إلى تسجيل الدخول",
  proceedToLogin: "الانتقال إلى تسجيل الدخول",
  continueButton: "المتابعة",
};

export default authentication;
